// Auto-refactored from translations.js on 2026-08-19
// Locale: bg

const bg = {
  wieMoeglich: { question: 'Как е възможно това?', answer: 'Преосмислихме веригата на стойността.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Пътят STIG ROCK',
    fazit: 'Скъсената верига на доставки премахва най-големите разходни позиции.',
    fazitBigPre: 'Това позволява отстъпка до',
    fazitBigValue: '80%',
    steps: [ 'Мина', 'Шлифовъчна работилница', 'Сертифициране', 'Краен клиент' ]
  },
  nav: { language: 'Език', contact: 'Контакт' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Една уникална възможност',
    subtitle: 'Изградете активи с поглед към бъдещето.',
    description: 'STIG ROCK е международна платформа, която предоставя на хората достъп до природни диаманти, устойчиво изграждане на богатство и уникална общност.',
    scroll: 'Скролнете, за да откриете'
  },
  disclaimer: {
    overline: 'Правна информация',
    title: 'Disclaimer',
    paragraphs: [
      'Тази презентация служи единствено за информация и не представлява финансова, инвестиционна или данъчна консултация.',
      'STIG ROCK не е финансов продукт, а се отнася до естествени Diamond като реални активи.',
      'Не се поема гаранция за развитие на стойността, печалби или доходи. Минали резултати не са индикация за бъдещи резултати.',
      'Всички представени изчисления във връзка с комисионни са само примерни и също не представляват гаранция.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'ИЗГРАДЕН', 'ВЪРХУ СТРУКТУРА' ],
    body: 'STIG GROUP е международен концерн, изграден върху яснота, отговорност и дългосрочна стойност. Всяка марка, всяко начинание и всяко Partner-ство следват един-единствен стандарт — без преки пътища, без изключения.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'ИЗГРАДЕН', 'ВЪРХУ СТРУКТУРА' ],
        body: 'STIG GROUP е международен концерн, изграден върху яснота, отговорност и дългосрочна стойност. Всяка марка, всяко начинание и всяко Partner-ство следват един-единствен стандарт — без преки пътища, без изключения.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'СВЕТЪТ НА', 'ЕКСКЛУЗИВНИТЕ DIAMOND' ],
        body: 'STIG ROCK е модерна концепция на STIG GROUP, която съчетава висококачествени GIA-сертифицирани Diamond с прозрачни структури и ексклузивно клиентско изживяване. Ясни планове за решение, професионално изпълнение и международна ориентация.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'МЕЖДУНАРОДНА', 'ТЪРГОВИЯ С DIAMOND' ],
        body: 'STIG INTERNATIONAL е част от STIG GROUP и е специализирана в международната търговия с GIA-сертифицирани Diamond. Фокус върху качеството, доверието и модерните търговски структури с глобални Partner-ства.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ОТГОВОРНОСТ', 'ОТ САМАТА МИНА' ],
        body: 'ETHICAL MINES означава отговорен добив, проследим произход и конфликтно свободни Diamond. От мината до пазара — пълна документация за прозрачност, интегритет и дългосрочна отговорност по цялата верига на доставки.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Диаманти',
    stigDrawback: 'Реален съхранител на стойност',
    overline: 'Възможности',
    title: 'Възможности за изграждане на активи',
    subtitle: 'Сравнение с традиционните пътища.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex или крипто',
        drawback: 'силно спекулативно, непредвидимо, сложно'
      },
      {
        tag: 'Aktien',
        name: 'Борсова търговия',
        drawback: 'риск от колебания, необходими знания, времеемко'
      },
      {
        tag: 'Krypto',
        name: 'Търговия',
        drawback: 'волатилност, регулаторен риск, пропуски в сигурността'
      }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'Подценената възможност',
    body: 'Diamond от години са сред най-стабилните по отношение на стойността и перспективни форми на инвестиция, но досега малцина са се възползвали от този потенциал.',
    callout: 'С нашия STIG ROCK за първи път отваряме достъпа до тези изключителни възможности за всички.'
  },
  wertentwicklung: {
    overline: 'Развитие на стойността 1995 — 2025',
    title: 'История на стойността.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Развитие от 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Основни причини',
    title: 'Шест причини за Diamond',
    lead: 'Diamond са реални активи, които съществуват независимо от валути и финансови системи — и запазват стойността си от векове.',
    items: [
      {
        n: '01',
        title: 'Стабилност срещу кризи',
        body: 'Гаранция за реален актив. Независимост от валути и финансови системи.'
      },
      {
        n: '02',
        title: 'Ултимативна мобилност',
        body: 'Малки, лесни за скриване и транспортиране.'
      },
      {
        n: '03',
        title: 'Диверсификация и дефицит',
        body: 'Недостиг в предлагането и природни ограничения.'
      },
      { n: '04', title: 'Дългосрочен растеж', body: '+185% от 1995 г.' },
      {
        n: '05',
        title: 'Прозрачност и ексклузивност',
        body: '4-те C като гаранция: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Резерв на кралските фамилии',
        body: 'Дори кралските фамилии използват Diamond като резерв от активи.'
      }
    ]
  },
  markt: {
    overline: 'Пазарен обем',
    title: '99 — 108 Mrd. USD',
    sub: 'Търговски обем през 2025 г.',
    forecast: 'Прогноза до ~2032 / 2034: ок. 140 – 168 Mrd. USD при умерен растеж (~4 – 5 % p.a.).',
    source: 'Източник: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovation',
    title: 'Една иновация. За първи път в света.',
    body: 'STIG ROCK е първата платформа в света, която позволява на хората да генерират пасивен доход на пазара на диаманти в допълнение към повишаването на стойността им.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, ОАЕ',
      'Регистрационен № DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'За компанията',
    titleLines: [ 'МЕЖДУНАРОДНА', 'СТРУКТУРА', 'ЯСНА ВИЗИЯ' ],
    body: 'STIG ROCK бе създаден, за да направи пазара на диаманти по-прозрачен, модерен и ориентиран към клиента — с фокус върху доверието, сигурността и дългосрочната структура.'
  },
  sicherheit: {
    overline: 'Качество и сигурност',
    title: 'Gemological Institute of America',
    body: 'Сертифицирана експертиза за вашите Diamond. Маг. Томас Адлер от GIA оценява всеки камък с най-висока точност и дългогодишен опит — надеждни експертни оценки за нашата компания и нашите клиенти.',
    transparency: 'Всеки Diamond отговаря на най-високи стандарти за качество и се проверява и сертифицира от реномирани организации. Всеки камък е уникален и получава индивидуален сертификат.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Уникална продуктова иновация',
    sub: 'Шест степенувани Solution Pläne — от $1K до $100K+, всеки с нарастваща отстъпка на месец и за целия период.',
    recommended: 'Популярен',
    oneYear: '1 година',
    rowLabels: {
      delivery: 'Срок за доставка',
      price: 'Цена на продукта',
      carat: 'ct',
      monthly: 'Отстъпка (месец)',
      totalDiscount: 'Отстъпка (общо)',
      duration: 'Срок'
    },
    headers: {
      plan: 'План',
      from: 'От',
      carat: 'ct',
      monthly: 'Отстъпка / мес.',
      total: 'Отстъпка общо',
      duration: 'Срок'
    },
    duration: '1 година',
    footnote: 'Всички цени са без гаранция и зависят от качеството, търсенето и актуалното развитие на пазара. Solution планове са възможни и за 2 години.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-пакет',
    title: 'Повече предимства с VIP-Paket',
    sub: 'Комбинирай своя Solution Plan с VIP-Paket и се възползвай от допълнителни ценови предимства до 3%. Така увеличаваш общата си отстъпка и си осигуряваш още по-атрактивни условия.',
    rowLabels: {
      delivery: 'Срок за доставка',
      price: 'Цена на продукта',
      carat: 'ct',
      monthly: 'Отстъпка (месец)',
      totalDiscount: 'Отстъпка (общо)',
      vip1: 'VIP-пакет 1 (+1%)',
      vip2: 'VIP-пакет 2 (+2%)',
      vip3: 'VIP-пакет 3 (+3%)'
    },
    footnote: 'Всички цени са без гаранция и зависят от качеството, търсенето и актуалното развитие на пазара.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Повече предимства с VIP-Paket',
    sub: 'Комбинирай своя Solution Plan с VIP-Paket и се възползвай от допълнителни ценови предимства до 3%. Така увеличаваш общата си отстъпка и си осигуряваш още по-атрактивни условия.',
    options: [
      {
        key: 'deliver',
        title: 'Повече предимства с VIP-Paket',
        body: 'Diamond (ct) на цената на вашия DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Продажба на нас',
        body: 'Можете да ни продадете обратно вашите Diamond на платената от вас покупна цена.'
      },
      {
        key: 'sellThirdParty',
        title: 'Продажба на трети страни',
        body: 'Можете да препродадете вашите Diamond на трети страни.'
      }
    ],
    footnote: '*DS-Plan означава Solution план.'
  },
  tradWeg: {
    overline: 'Традиционна търговия',
    title: 'Традиционният път',
    sub: 'Преди един Diamond да достигне до крайния клиент, се създават значителни търговски надценки от посредници, търговци на едро и дребно в сравнение с цената на необработения диамант от мината.',
    steps: [
      { title: 'Мина', subtitle: 'Необработени диаманти' },
      { title: 'Посредник', subtitle: 'Покупка на необработени диаманти' },
      { title: 'Шлифоване', subtitle: 'Шлифоване на бижутерски диаманти' },
      { title: 'Сертифициране', subtitle: 'от признати институти като GIA' },
      { title: 'Борса за диаманти', subtitle: 'Продажба на търговци на едро' },
      { title: 'Търговия на едро', subtitle: 'Продажба на търговци на дребно' },
      { title: 'Търговия на дребно', subtitle: 'напр. бижутери' },
      { title: 'Крайни клиенти', subtitle: 'Покупка на Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-пакети',
    sub: 'Валидни за 12 месеца за всички сключени от вас Solution планове. В зависимост от VIP-пакета: +1% до +3% допълнителна отстъпка',
    cardKicker: 'допълнително – за всички',
    cardKicker2: 'Solution планове',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Отстъпките стават спестявания',
      body: 'Месечни спестявания вместо месечни разходи. Отстъпките генерират спестявания – и те плащат точно за нещата, за които иначе плащате всеки месец от собствения си джоб.',
      line1Label: 'DS-Plan от',
      line1Value: '$5.000',
      line2Label: 'мес. отстъпка',
      line2Value: '3%',
      line3Label: 'VIP-пакет 3',
      line3Value: '+3%',
      resultLabel: 'мес. спестявания',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Как е възможно това?',
    title: 'Преосмислихме веригата за създаване на стойност.',
    traditionalTitle: 'Традиционният път',
    traditionalSteps: [
      'Мина — необработени диаманти',
      'Посредник — покупка',
      'Шлифоване — шлифовка',
      'Сертифициране (GIA)',
      'Борса за диаманти — търговия на едро',
      'Търговия на едро → Търговия на дребно',
      'Бижутери → Краен клиент'
    ],
    traditionalNote: 'Преди един Diamond да достигне до крайния клиент, се създават значителни търговски надценки от посредници, търговци на едро и дребно.',
    stigTitle: 'Пътят на STIG ROCK',
    stigSteps: [
      'Директна покупка — необработени диаманти от мината',
      'Шлифоване и сертифициране от нашите Partner-и',
      'Продажба на крайни клиенти и B2B клиенти',
      'До 4 търговски цикъла на година'
    ],
    stigNote: 'Ние прекъсваме цикъла и предаваме търговските надценки като кредити за отстъпка на нашите клиенти — до 4 търговски цикъла по време на DS-Plan срока.'
  },
  optionen: {
    overline: 'Вашите възможности',
    title: 'След изтичане на вашия Solution план',
    items: [
      { title: 'Доставка', body: 'Diamond (ct) на цената на вашия DS-Plan.' },
      {
        title: 'Продажба на нас',
        body: 'Обратно изкупуване на платената от вас покупна цена.'
      },
      {
        title: 'Продажба на трети страни',
        body: 'Продажба на Diamond на свободния пазар.'
      }
    ]
  },
  einfacherWeg: {
    overline: 'Solution планове — уникална продуктова иновация',
    title: 'Лесният път',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Регистрация',
        body: 'Свържете се с вашия препоръчител и създайте безплатен акаунт!'
      },
      { n: '02', icon: 'cart', title: 'Покупка на продукт', body: 'Още от $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Получаване на отстъпки',
        body: 'Получавайте месечни кредити за отстъпка.'
      }
    ]
  },
  business: {
    overline: 'Видове бонуси',
    title: 'Най-лесният и честен път.',
    sub: 'Пет вида бонуси — за вашето успешно изграждане на бизнес.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'До ниво 3, от кариерно ниво Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'От Sapphire — в неограничена дълбочина.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Върху Infinity Bonus – до ниво 5 · БЕЗ квалификация.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 пула от световния оборот.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Еднократен бонус в Diamond (ct).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Този бонус ви се изплаща за всеки нов сключен Solution план до 3-то ниво. С много малки квалификации отключвате отделните нива.',
    total: 'До 18% Unilevel Bonus',
    levels: [
      {
        level: 'Ниво 1',
        value: '10%',
        qual: 'от самото начало',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Ниво 2',
        value: '5%',
        qual: 'от кариерно ниво Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Ниво 3',
        value: '3%',
        qual: 'от кариерно ниво Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'От кариерно ниво Sapphire сте квалифицирани за нашия Infinity Bonus план. Получавате 3% бонус. С всяко ново кариерно ниво се добавят допълнителни проценти. Ако Partner във вашия екип също е квалифициран, получавате разликата от ранг до ранг.',
    exampleTitle: 'Пример',
    exampleRows: [
      { label: 'Вие сте Blue Diamond', value: '12%' },
      { label: 'Вашият Partner е Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Вашият Infinity Bonus', value: '9%' },
    totalNote: 'Общо до 24% Infinity Bonus върху всички сключени Solution планове във вашия екип — в неограничена дълбочина.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'С този бонус печелите от успеха на вашия екип. Получавате Matching Bonus от 5% върху Infinity Bonus на вашите Partner-и — и то до 5-то ниво на вашия екип.',
    note: 'Върху всички плащания на Infinity Bonus във вашия екип – до 5-то ниво. От самото начало – БЕЗ квалификация.',
    levels: [
      { level: 'Ниво 1', value: '5%' },
      { level: 'Ниво 2', value: '5%' },
      { level: 'Ниво 3', value: '5%' },
      { level: 'Ниво 4', value: '5%' },
      { level: 'Ниво 5', value: '5%' }
    ],
    totalPrefix: 'Общо до',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% от световния оборот отиват на равни части в 3 различни пула. С постигането на определени кариерни нива се квалифицирате за всеки отделен пул.',
    forever: 'Веднъж достигнато – участие ЗАВИНАГИ!',
    pools: [
      { key: 'p1', label: 'Пул 1', value: '1%', qual: 'от Blue Diamond' },
      { key: 'p2', label: 'Пул 2', value: '1%', qual: 'от Purple Diamond' },
      { key: 'p3', label: 'Пул 3', value: '1%', qual: 'от Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Общо',
    totalValue: '3%',
    totalSuffix: 'от световния оборот'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'От кариерно ниво Diamond получавате Rang Bonus. Той се изплаща в Diamond (ct). Това е еднократен бонус.',
    highlight: 'Diamond (ct) на обща стойност',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Кариерни нива',
    title: 'Кариерни нива',
    sub: 'За достигане на съответните кариерни нива се отчита историческият общ оборот (HG). От ниво Sapphire той трябва да бъде разпределен между няколко екипа. За достигане на Ruby или по-високо са ви необходими поне двама директни Partner-и с Solution план.',
    forever: 'Веднъж достигнато – потвърдено ЗАВИНАГИ!',
    footnote: 'HV = Исторически общ оборот.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 дир. Partner-и', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Дайте старт с нас',
    title: 'Точният момент е точно сега.',
    body: 'Този бизнес модел поставя нови стандарти и обединява всички фактори за успех за един дългосрочно устойчив и успешен бизнес. Регистрирайте се днес, изберете своя Solution план и се възползвайте от тази уникална бизнес възможност.',
    hint: 'Говорете с човека, който ви покани на тази презентация — той има регистрационен линк за вас.',
    formName: 'Име',
    formEmail: 'E-mail',
    formPhone: 'Телефон',
    formSubmit: 'Свържете се с нас',
    success: 'Благодарим ви — ще се свържем с вас дискретно и лично.',
    callCta: 'Обаждане',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Правна информация & Disclaimer',
    disclaimer: 'Тази презентация служи единствено за информация и не представлява финансова, инвестиционна или данъчна консултация. STIG ROCK не е финансов продукт, а се отнася до естествени Diamond като реални активи. Не се поема гаранция за развитие на стойността, печалби или доходи. Минали резултати не са индикация за бъдещи резултати. Всички представени изчисления във връзка с комисионни са само примерни и също не представляват гаранция. Запазено право на промени в съдържанието — свободен превод (не е официален превод).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, ОАЕ',
    copy: '© 2026 STIG International. Всички права запазени.',
    version: 'Версия: DS-12-2025 V3'
  },
  misc: { next: 'Следваща секция' }
};

export default bg;
